"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'Run JavaScript',
    description: 'Run custom JavaScript code',
});
//# sourceMappingURL=run-javascript.js.map